import { STATUS } from "../../../../constants";

export const alertMessageMapping = {
  [STATUS.SUCCEED]: {
    type: "success",
    message: "Create specialist available dates success.",
  },
  [STATUS.FAILED]: {
    type: "error",
    message: "There has an error during creating specialist available dates, please try again.",
  },
};
